import { useMemo } from "react"
import PropTypes from "prop-types"
import { Table, TableHead, TableRow } from "@mui/material"
import LinkIcon from "@mui/icons-material/Link"
import ContributorsSorting from "components/contributors-sorting"
import ContributorsTableContent from "components/contributors-table-content"
import ContributorsDetailsTableTopRow from "./top-row"
import "./style.scss"

function ContributorsDetailsTable({
  selected,
  data,
  openSecurityProfile,
  openFactorProfile,
  openCompositeSecurity,
  openBasket,
  selectedGroup,
  selectedGroupSiblings,
  groupsDropdownColumns,
  selectedBasket,
  showGroup,
  hideGroup,
  closeBasket,
  contributorsGrouping,
  groupedData,
  sort,
  order,
  refEquityOverride,
  enableBasketDrillDown,
  page,
  setPage,
}) {
  const basketTopRow = useMemo(() => {
    if (!selectedBasket || !enableBasketDrillDown) return null
    const { ticker, exchange } = selectedBasket.ticker
    return (
      <ContributorsDetailsTableTopRow
        name={ticker}
        hide={closeBasket}
        icon={<LinkIcon />}
        onIconClick={() => openSecurityProfile(exchange, ticker)}
      />
    )
  }, [selectedBasket, closeBasket, openSecurityProfile, enableBasketDrillDown])

  const groupTopRow = useMemo(() => {
    if (!selectedGroup) return null
    return (
      <ContributorsDetailsTableTopRow
        name={selectedGroup.name}
        hide={hideGroup}
        groupChange={(group) => showGroup(group)}
        className={basketTopRow && "second"}
        selectedGroupSiblings={selectedGroupSiblings}
        groupsDropdownColumns={groupsDropdownColumns}
        selectedGroup={selectedGroup}
      />
    )
  }, [basketTopRow, selectedGroup, hideGroup, showGroup, selectedGroupSiblings, groupsDropdownColumns])

  return (
    <div className="table-wrapper">
      <Table className="contributors-details-table">
        <TableHead>
          <TableRow className="sorting-row">
            <ContributorsSorting label="Name" id="name" order={order} sort={sort} />
            <ContributorsSorting label={refEquityOverride ? "% Equity" : "% GMV"} id="economicExposure" align="right" order={order} sort={sort} />
          </TableRow>
          {basketTopRow}
          {groupTopRow}
        </TableHead>
        <ContributorsTableContent
          noPercent
          hideSelectedField
          selected={selected}
          openSecurityProfile={openSecurityProfile}
          openFactorProfile={openFactorProfile}
          openCompositeSecurity={openCompositeSecurity}
          openBasket={openBasket}
          data={data}
          contributorsGrouping={contributorsGrouping}
          selectedGroup={selectedGroup}
          selectedBasket={selectedBasket}
          showGroup={showGroup}
          hideGroup={hideGroup}
          groupedData={groupedData}
          enableBasketDrillDown={enableBasketDrillDown}
          page={page}
          setPage={setPage}
        />
      </Table>
    </div>
  )
}

ContributorsDetailsTable.propTypes = {
  selected: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  openBasket: PropTypes.func,
  selectedGroup: PropTypes.object,
  selectedGroupSiblings: PropTypes.array,
  groupsDropdownColumns: PropTypes.array.isRequired,
  selectedBasket: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  closeBasket: PropTypes.func,
  contributorsGrouping: PropTypes.object,
  groupedData: PropTypes.array,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  refEquityOverride: PropTypes.bool,
  enableBasketDrillDown: PropTypes.bool,
  page: PropTypes.number,
  setPage: PropTypes.func,
}

export default ContributorsDetailsTable
